<template>
  <v-navigation-drawer
    v-model="drawer"
    right
    temporary
    fixed
    width="420"
    class="catalog-cart-drawer"
  >
    <div class="cart-shell">
      <div class="cart-header">
        <div>
          <div class="cart-title">Review Cart</div>
          <div class="cart-subtitle">
            {{ totalQty }} items · {{ total | currency }}
          </div>
        </div>

        <v-btn icon @click="drawer = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </div>

      <div v-if="!items.length" class="empty-cart">
        No items added yet.
      </div>

      <div v-else class="cart-list">
        <div
          v-for="(item, index) in items"
          :key="item.ProductId"
          class="cart-item"
        >
          <div class="cart-item-main">
            <div class="cart-item-name">{{ item.name }}</div>
            <div class="cart-item-sub">
              {{ item.qty }} × {{ item.price | currency }}
            </div>

            <div class="cart-inline-actions">
              <v-btn icon small @click="$emit('minus', item.Product)">
                <v-icon color="red">mdi-minus-circle</v-icon>
              </v-btn>

              <v-btn small outlined rounded @click="$emit('open-qty', item.Product)">
                {{ item.qty }}
              </v-btn>

              <v-btn icon small @click="$emit('add', item.Product)">
                <v-icon color="primary">mdi-plus-circle</v-icon>
              </v-btn>
            </div>
          </div>

          <div class="cart-item-side">
            <div class="cart-item-total">
              {{ item.total | currency }}
            </div>

            <v-btn icon x-small @click="confirmRemove(item, index)">
              <v-icon color="red">mdi-delete-outline</v-icon>
            </v-btn>
          </div>
        </div>
      </div>

      <div class="cart-footer">
        <div class="footer-total-row">
          <span>Total</span>
          <strong>{{ total | currency }}</strong>
        </div>

        <v-btn
          color="primary"
          rounded
          dark
          block
          large
          :loading="saving"
          :disabled="!items.length"
          @click="$emit('save')"
        >
          Save Order
        </v-btn>
      </div>
    </div>
  </v-navigation-drawer>
</template>

<script>
export default {
  name: "CatalogCartDrawer",

  props: {
    value: {
      type: Boolean,
      default: false,
    },
    items: {
      type: Array,
      default: () => [],
    },
    totalQty: {
      type: Number,
      default: 0,
    },
    total: {
      type: Number,
      default: 0,
    },
    saving: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    drawer: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },

  methods: {
    confirmRemove(item, index) {
      this.$swal({
        title: "Remove item?",
        html: `Are you sure you want to remove <b>${item.name}</b>?`,
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
      }).then((result) => {
        if (result.value) {
          this.$emit("remove", index);
        }
      });
    },
  },
};
</script>

<style scoped>
.catalog-cart-drawer {
  z-index: 30;
}

.cart-shell {
  height: 100vh;
  display: flex;
  flex-direction: column;
  background: #ffffff;
}

.cart-header {
  flex: 0 0 auto;
  padding: 16px;
  border-bottom: 1px solid #e2e8f0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #ffffff;
  z-index: 2;
}

.cart-title {
  font-size: 20px;
  font-weight: 900;
  color: #0f172a;
}

.cart-subtitle {
  font-size: 13px;
  color: #64748b;
  margin-top: 2px;
}

.empty-cart {
  flex: 1 1 auto;
  padding: 18px;
  color: #64748b;
  text-align: center;
}

.cart-list {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
  padding-bottom: 12px;
}

.cart-item {
  padding: 12px 14px;
  border-bottom: 1px solid #f1f5f9;
  display: flex;
  justify-content: space-between;
  gap: 10px;
}

.cart-item-name {
  font-size: 13px;
  font-weight: 800;
  color: #0f172a;
}

.cart-item-sub {
  font-size: 12px;
  color: #64748b;
  margin-top: 2px;
}

.cart-inline-actions {
  margin-top: 8px;
  display: flex;
  align-items: center;
  gap: 4px;
}

.cart-item-side {
  text-align: right;
  white-space: nowrap;
}

.cart-item-total {
  font-weight: 900;
  color: #0f172a;
}

.cart-footer {
  flex: 0 0 auto;
  background: #ffffff;
  border-top: 1px solid #e2e8f0;
  padding: 14px;
  padding-bottom: calc(14px + env(safe-area-inset-bottom));
  box-shadow: 0 -6px 18px rgba(15, 23, 42, 0.08);
  z-index: 2;
}

.footer-total-row {
  display: flex;
  justify-content: space-between;
  font-size: 18px;
  margin-bottom: 12px;
}

.cart-footer .v-btn {
  min-height: 48px;
}

@media (max-width: 600px) {
  .catalog-cart-drawer {
    width: 100% !important;
  }
}
</style>